var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import Box from "./Box";
import { ARROW_LEFT_SVG, ARROW_RIGHT_SVG } from "../assets";
import TimeAgo from 'react-timeago';
import * as uuid from "uuid";
var NewsListViewLayout = /** @class */ (function () {
    function NewsListViewLayout() {
    }
    NewsListViewLayout.registerContainer = function (container, componentId) {
        if (container) {
            NewsListViewLayout.containerRegistry[componentId] = container;
            NewsListViewLayout.listen();
        }
    };
    NewsListViewLayout.unregisterComponent = function (componentId) {
        delete NewsListViewLayout.containerRegistry[componentId];
        delete NewsListViewLayout.updateCallbackRegsitry[componentId];
        if (NewsListViewLayout.listeningComponentId == componentId) {
            NewsListViewLayout.removeListener();
        }
        NewsListViewLayout.listen();
    };
    NewsListViewLayout.listen = function () {
        if (!NewsListViewLayout.listeningComponentId) {
            if (Object.keys(NewsListViewLayout.containerRegistry).length > 0) {
                var newCompKey = Object.keys(NewsListViewLayout.containerRegistry)[0];
                NewsListViewLayout.listeningComponentId = newCompKey;
                if (NewsListViewLayout.availableWidth != NewsListViewLayout.getAvailableWidth()) {
                    NewsListViewLayout.callListeners();
                }
                window.addEventListener('resize', NewsListViewLayout.onResize);
                window.addEventListener('orientationchange', NewsListViewLayout.onResize);
            }
        }
    };
    NewsListViewLayout.removeListener = function () {
        NewsListViewLayout.listeningComponentId = undefined;
        window.removeEventListener('resize', NewsListViewLayout.onResize);
        window.removeEventListener('orientationchange', NewsListViewLayout.onResize);
    };
    NewsListViewLayout.registerListener = function (componentId, cb) {
        NewsListViewLayout.updateCallbackRegsitry[componentId] = cb;
    };
    NewsListViewLayout.callListeners = function () {
        if (NewsListViewLayout.availableWidth != NewsListViewLayout.getAvailableWidth()) {
            NewsListViewLayout.availableWidth = NewsListViewLayout.getAvailableWidth();
            NewsListViewLayout.didCalcualte = true;
            Object.keys(NewsListViewLayout.updateCallbackRegsitry).forEach(function (k) {
                NewsListViewLayout.updateCallbackRegsitry[k]();
            });
        }
    };
    NewsListViewLayout.onResize = function () {
        clearTimeout(NewsListViewLayout.resizeTimer);
        NewsListViewLayout.resizeTimer = setTimeout(function () {
            if (NewsListViewLayout.listeningComponentId && NewsListViewLayout.containerRegistry[NewsListViewLayout.listeningComponentId]) {
                NewsListViewLayout.callListeners();
            }
        }, 350);
    };
    NewsListViewLayout.getAvailableWidth = function () {
        if (NewsListViewLayout.listeningComponentId && NewsListViewLayout.containerRegistry[NewsListViewLayout.listeningComponentId]) {
            try {
                return parseInt(window.getComputedStyle(NewsListViewLayout.containerRegistry[NewsListViewLayout.listeningComponentId], null).getPropertyValue('width').replace('px', ''));
            }
            catch (error) {
                return NewsListViewLayout.containerRegistry[NewsListViewLayout.listeningComponentId].clientWidth - 50; // 50 for padding
            }
        }
        return window.innerWidth;
    };
    NewsListViewLayout.calcNumberToShow = function () {
        var width = NewsListViewLayout.availableWidth;
        width -= 20; // minimum margin
        return Math.min(5, Math.floor(width / ItemWidth));
    };
    NewsListViewLayout.calcMargin = function () {
        var width = NewsListViewLayout.availableWidth;
        var numberToShow = NewsListViewLayout.calcNumberToShow();
        var rest = width - (numberToShow * ItemWidth);
        return { marginRight: rest / numberToShow };
    };
    NewsListViewLayout.containerRegistry = {};
    NewsListViewLayout.updateCallbackRegsitry = {};
    NewsListViewLayout.availableWidth = NewsListViewLayout.getAvailableWidth();
    NewsListViewLayout.didCalcualte = false;
    return NewsListViewLayout;
}());
var ItemWidth = 280;
var MaxItems = 5;
var NewsListView = /** @class */ (function (_super) {
    __extends(NewsListView, _super);
    function NewsListView(props) {
        var _this = _super.call(this, props) || this;
        _this.componentId = uuid.v4();
        _this.state = {
            page: 1,
        };
        return _this;
    }
    Object.defineProperty(NewsListView.prototype, "container", {
        get: function () {
            return this._container;
        },
        set: function (val) {
            this._container = val;
            NewsListViewLayout.registerContainer(val, this.componentId);
        },
        enumerable: true,
        configurable: true
    });
    NewsListView.prototype.componentWillMount = function () {
        var _this = this;
        NewsListViewLayout.registerListener(this.componentId, function () {
            _this.forceUpdate();
        });
    };
    NewsListView.prototype.componentWillUnmount = function () {
        NewsListViewLayout.unregisterComponent(this.componentId);
    };
    NewsListView.convertText = function (text) {
        var linkRegex = /\$LINK_DATA((\s|.)+?)LINK_DATA\$/g;
        var imageRegex = /\$IMAGE_DATA((\s|.)+?)IMAGE_DATA\$/g;
        var songsRegex = /\$SONG_DATA((\s|.)+?)SONG_DATA\$/g;
        var songsNewlineRegex = /SONG_DATA\$(\s|\\n+|\R)\$SONG_DATA/g;
        var youtubeRegex = /\$YOUTUBE_VIDEO((\s|.)+?)YOUTUBE_VIDEO\$/g;
        return text.replace(linkRegex, '').replace(imageRegex, '').replace(songsRegex, '').replace(songsNewlineRegex, '').replace(youtubeRegex, '');
    };
    NewsListView.prototype.scrollTo = function (element, to, duration) {
        var _this = this;
        clearTimeout(this.scrollTimer);
        var start = element.scrollLeft, change = to - start, currentTime = 0, increment = 20;
        var animateScroll = function () {
            currentTime += increment;
            var val = Math.easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if (currentTime < duration) {
                _this.scrollTimer = setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    };
    NewsListView.prototype.render = function () {
        var _this = this;
        var items = this.props.items;
        var marginRight = NewsListViewLayout.calcMargin().marginRight;
        return React.createElement("div", { style: this.props.style, className: this.props.className },
            React.createElement(Box, { className: "newsfeedlist-container" },
                React.createElement("div", { className: "top", ref: function (ref) { return _this.container = ref; } },
                    React.createElement("h3", { className: "set-title" }, this.props.title),
                    React.createElement("div", { className: 'view-all-container' },
                        React.createElement("div", { className: this.state.page == 1 ? 'inactive' : '', onClick: function () {
                                if (_this.state.page > 1)
                                    _this.setState({ page: _this.state.page - 1 }, function () {
                                        if (_this.container && _this.listView) {
                                            _this.scrollTo(_this.listView, NewsListViewLayout.availableWidth * (_this.state.page - 1), 300);
                                        }
                                    });
                            } },
                            React.createElement("img", { src: ARROW_LEFT_SVG })),
                        React.createElement("div", { className: this.state.page == (Math.ceil(this.props.items.length / NewsListViewLayout.calcNumberToShow())) ? 'inactive' : '', onClick: function () {
                                if (_this.state.page < Math.ceil(_this.props.items.length / NewsListViewLayout.calcNumberToShow()))
                                    _this.setState({ page: _this.state.page + 1 }, function () {
                                        if (_this.container && _this.listView) {
                                            _this.scrollTo(_this.listView, NewsListViewLayout.availableWidth * (_this.state.page - 1), 300);
                                        }
                                    });
                            } },
                            React.createElement("img", { src: ARROW_RIGHT_SVG })))),
                NewsListViewLayout.didCalcualte && React.createElement("div", { className: "newsfeed-listview", ref: function (ref) { return _this.listView = ref; } }, items.chunk(NewsListViewLayout.calcNumberToShow()).map(function (section, i) {
                    var visible = _this.state.page == (i + 1);
                    return React.createElement("section", { key: i, style: section.length == 1 ? { minWidth: NewsListViewLayout.availableWidth + "px" } : {} }, section.map(function (s, inner_index) {
                        var style = {
                            marginRight: (inner_index == (section.length - 1) ? marginRight - 10 : marginRight) + "px",
                            marginLeft: (inner_index == 0 ? 10 : 0) + "px"
                        };
                        if (section.length == 1) {
                            style.marginLeft = 'auto';
                            style.marginRight = 'auto';
                        }
                        return React.createElement("div", { className: "set", key: s.id, onClick: function (e) {
                                _this.props.onClick && _this.props.onClick(s);
                            }, style: __assign({ width: ItemWidth + "px", flex: "0 0 " + ItemWidth + "px" }, style) },
                            React.createElement("div", { className: "set-img" },
                                React.createElement("img", { src: visible ? s.image_url : undefined })),
                            React.createElement("div", { className: "set-description" },
                                React.createElement("div", { className: "set-date" },
                                    React.createElement(TimeAgo, { date: s.posted_date })),
                                React.createElement("div", { className: "set-title" }, s.title),
                                React.createElement("div", { className: "set-description" }, NewsListView.convertText(s.rendered))));
                    }));
                }))));
    };
    return NewsListView;
}(React.PureComponent));
export default NewsListView;
//# sourceMappingURL=NewsListView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/NewsListView.js
// module id = 1290
// module chunks = 0